import { useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const LogoutButton = ({ className = "" }) => {
  const { logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const confirm = async () => { setBusy(true); await logout(); setOpen(false); setBusy(false); nav("/"); };
  return (
    <>
      <button onClick={() => setOpen(true)} className={`flex items-center gap-1.5 px-3 py-2 border border-white/15 text-xs uppercase tracking-widest font-semibold text-white hover:border-[#FF6A00] hover:text-[#FF6A00] whitespace-nowrap ${className}`} data-testid="nav-logout-btn">
        <LogOut className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Log out</span>
      </button>
      {open && createPortal(
        <div className="fixed inset-0 z-[100] bg-black/85 flex items-center justify-center p-4" data-testid="logout-confirm-modal">
          <div className="w-full max-w-sm border border-white/10 bg-[#121212] p-6" onClick={(e) => e.stopPropagation()}>
            <div className="font-mono-data text-xs tracking-widest text-[#FF6A00]">// LOG OUT</div>
            <h2 className="mt-1 font-display font-black text-2xl uppercase tracking-tight">Are you sure you want to log out?</h2>
            <p className="mt-2 text-sm text-zinc-400">You'll need to sign in again to see your bookings and offers.</p>
            <div className="mt-6 flex gap-2">
              <button onClick={() => setOpen(false)} className="flex-1 border border-white/20 text-white uppercase tracking-widest text-xs font-bold py-3 hover:border-[#FF6A00] hover:text-[#FF6A00]" data-testid="logout-cancel-btn">Stay signed in</button>
              <button onClick={confirm} disabled={busy} className="flex-1 bg-[#FF6A00] text-black uppercase tracking-widest text-xs font-black py-3 hover:bg-white disabled:opacity-60" data-testid="logout-confirm-btn">{busy ? "…" : "Log out"}</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};
